import React from 'react';
import withStyles from 'isomorphic-style-loader/lib/withStyles';
import cx from 'classnames';

import s from './FooterConsole.scss';

const FooterConsole = ({ auth = false }) => (
  <footer className={cx('Footer', { '--auth': auth })}>
    <div>©Henkel Consumer Brands Canada Corporation {new Date().getFullYear()}</div>

    <ul className="Footer__list">
      {/* <li className="Footer__listItem">
          <a
            href="https://myskp-usa.zendesk.com/hc/en-us/requests/new"
            target="_blank"
            rel="noreferrer"
          >
            Need Help?
          </a>
        </li> */}
      <li className="Footer__listItem">
        <a
          href="https://www.henkel-northamerica.com/terms-of-use-na?view=content-blank"
          target="_blank"
          rel="noreferrer"
        >
          Terms of Use
        </a>
      </li>
      <li className="Footer__listItem">
        <a
          href="https://www.henkel-northamerica.com/privacy-statement-na?view=content-blank"
          target="_blank"
          rel="noreferrer"
        >
          Privacy Policy
        </a>
      </li>
      <li className="Footer__listItem">
        <button onClick={() => window.Optanon.ToggleInfoDisplay()}>
          Cookies
        </button>
      </li>
    </ul>
  </footer>
);

export default withStyles(s)(FooterConsole);



// WEBPACK FOOTER //
// ./src/components/FooterConsole/FooterConsole.js